module.exports = __webpack_public_path__ + "static/wrow0-68e8725fe9011b242f45be1a115c9973.jpg";